<template>
    <section class="exchange-rate">
        <div v-if="conversionRateInfo"
            class="exchange-rate__info"
        >
            {{ conversionRateInfo }}
        </div>

        <loading-spinner v-else
            :radius="0.8"
            color="#9b9b9b"
        />
    </section>
</template>

<script>
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';

export default {
    name: 'exchange-rate',
    components: {
        loadingSpinner,
    },
    props: {
        conversionRateInfo: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.exchange-rate {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0.15rem solid $nobel-grey-color;
    background: $white-color;
    border-radius: 12.5rem;
    min-width: 15.1rem;
    height: 2.3rem;
    padding: 0 1rem;

    &__info {
        font-size: 1.1rem;
        line-height: 2.3rem;
        color: $nobel-grey-color;

        @include max-width(sm) {
            font-size: 0.9rem;
        }
    }

    @include max-width(sm) {
        font-size: 0.9rem;
        min-width: 12.1rem;
    }
}
</style>